module.exports = __webpack_public_path__ + "img/DB4-1920_07.5c336927.jpg";